import { render, staticRenderFns } from "./FormItemRadioGroup.vue?vue&type=template&id=0c4c5d30"
import script from "./FormItemRadioGroup.vue?vue&type=script&lang=ts"
export * from "./FormItemRadioGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports